import {
    GenerateTaskList,
    TaskStatus,
    TaskTemplate,
    useCheckLogin,
} from "@hg/recall-frame"
import cls from "classnames"
import classNames from "classnames"
import React, { FC, useMemo } from "react"
import OutlinedText from "@/components/OutlinedText"
import { i18n, RecallTextPath } from "@/i18n"
import { collect } from "@/utils/sdk"
import { useRoleInfo } from "@/user/session"
import styles from "./index.module.scss"
import { TASK_TEMPLATE_MAP } from "./task"

/** 通过 UA 判断是否在国内主流社交媒体 app 内嵌浏览器中 */
function isSocialAppWebView(): boolean {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent : ""
    const patterns = [
        /MicroMessenger/i, // 微信
        /Weibo/i, // 微博
        /QQ\//i, // QQ / QQ 浏览器
        /Aweme|ByteDance/i, // 抖音
        /Kwai|kuaishou/i, // 快手
        /xhs|redbook/i, // 小红书
        /BiliApp/i, // 哔哩哔哩 app
    ]
    return patterns.some((p) => p.test(ua))
}

export const Task: FC = () => {
    //埋点
    const onFinishSuccess = (template: string) => {
        collect("mission_confirm", {
            mission_id: `${template}`,
        })
        // toast(t("message.claim_task_success"))
    }

    return (
        <GenerateTaskList
            containerCls={styles.task}
            scrollCls={styles.scroll}
            scrollbarCls={styles.scrollbar}
            thumbCls={styles.thumb}
            renderTask={({ template, status, onClick }) => (
                <TaskItem key={template} {...{ template, status, onClick }} />
            )}
            onSuccess={onFinishSuccess}
        />
    )
}

const TaskItem: FC<{
    template: string
    status: TaskStatus
    onClick: () => void
}> = ({ template, status, onClick }) => {
    const role = useRoleInfo()
    const checkLogin = useCheckLogin("HG")

    const taskTemplate =
        TASK_TEMPLATE_MAP[template as keyof typeof TASK_TEMPLATE_MAP]

    const {
        introduction,
        reward_1_amount,
        reward_1_key,
        reward_2_amount,
        reward_2_key,
    } = taskTemplate

    const handleTaskBtnClick = () => {
        if (template === TaskTemplate.SHARE) {
            if (!role) {
                checkLogin()
                return
            }
            // //埋点
            if (
                status !== TaskStatus.COMPLETED &&
                status !== TaskStatus.ACCOMPLISHED
            ) {
                if (role) {
                    collect("event_share", {
                        target: `mission_${template}`,
                    })
                }
            }
        } else {
            const check = checkLogin()
            if (!check) {
                return
            }
        }
        let isOnClickCalled = false
        if (template === TaskTemplate.CASUAL && status === TaskStatus.INITIAL) {
            if (isSocialAppWebView()) {
                isOnClickCalled = true
                onClick()
                setTimeout(() => {
                    window.location.href = "https://ak.hypergryph.com/"
                }, 50)
            } else {
                window.open("https://ak.hypergryph.com/", "_blank")
            }
        }
        if (!isOnClickCalled) {
            onClick()
        }
    }

    if (!taskTemplate) {
        return
    }

    return (
        <div className={cls(styles.taskItem)}>
            <div className={styles.titleContainer}>
                <div className={styles.title}>
                    <span
                        className={styles.titleText}
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                        dangerouslySetInnerHTML={{
                            __html: i18n.getRecall(
                                introduction as RecallTextPath,
                            ),
                        }}
                    ></span>
                </div>
            </div>
            <div className={styles.rewards}>
                <Reward type={reward_1_key} amount={reward_1_amount} />
                <Reward type={reward_2_key} amount={reward_2_amount} />
            </div>
            <div className={styles.action}>
                <Button status={status} onClick={handleTaskBtnClick} />
            </div>
        </div>
    )
}

const Button = ({
    status,
    onClick,
}: {
    status: TaskStatus
    onClick: () => void
}) => {
    const btnStyle = useMemo(() => {
        return status === TaskStatus.COMPLETED
            ? styles.btn_finished
            : styles.btn_jump
    }, [status])

    const btnText = useMemo(() => {
        return status === TaskStatus.COMPLETED
            ? i18n.getRecall("task.btn_finished")
            : status === TaskStatus.ACCOMPLISHED
              ? i18n.getRecall("task.btn_claim")
              : i18n.getRecall("task.btn_jump")
    }, [status])

    const disabled = useMemo(() => {
        return status === TaskStatus.COMPLETED
    }, [status])

    return (
        <div
            className={btnStyle}
            onClick={() => {
                if (!disabled) {
                    onClick()
                }
            }}
        >
            <OutlinedText
                className={styles.btnText}
                text={btnText}
                fontSize={28}
                strokeWidth={6}
                fillColor={disabled ? "#917455" : "#ffffff"}
                strokeColor={disabled ? "#ffffff" : "#26818E"}
            />
        </div>
    )
}

const Reward: FC<{
    type: "lmb" | "hcy" | "chance" | null
    amount: number
}> = ({ type, amount }) => {
    const typeClass = type ? styles[type] : ""
    if (!amount) {
        return null
    }
    const text =
        type === "chance"
            ? `${i18n.getRecall("task.text_chance")}×${amount}`
            : `×${amount}`
    return (
        type && (
            <div className={classNames(styles.reward, !amount && styles.empty)}>
                <div className={cls(styles.image, typeClass)}></div>
                {!!amount && (
                    <div className={styles.rewardName}>
                        <OutlinedText
                            className={styles.amount}
                            text={text}
                            fontSize={20}
                            strokeWidth={6}
                            fillColor="#FDFCEB"
                            strokeColor="#907355"
                        />
                    </div>
                )}
            </div>
        )
    )
}
